<template>
  <div class="content">
    <div class="header">
      <el-button @click="pageChange(1)">查询</el-button>
      <el-button @click="setComponents('CustomerRentEditor')">新增出租</el-button>
      <el-button type="danger" size="mini" @click="deleteSms()">删除</el-button>
    </div>
    <div class="header-where">
      <el-descriptions size="mini" direction="vertical" :column="1" border>
        <el-descriptions-item label="查询条件">
          <el-descriptions size="mini" :column="2" border>
            <el-descriptions-item label="房产范围">
              {{where.house_name}}
            </el-descriptions-item>
            <el-descriptions-item label="业主名称">
              <el-input size="mini" v-model="where.txtOwnerName" clearable></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="放租日期">
              <el-date-picker
                v-model="where.dateArr[0]"
                type="date"
                @change="pageChange(1)"
                value-format="yyyy-MM-dd"
                clearable="false"
                placeholder="选择日期">
              </el-date-picker>
              至
              <el-date-picker
                v-model="where.dateArr[1]"
                type="date"
                @change="pageChange(1)"
                value-format="yyyy-MM-dd"
                clearable="false"
                placeholder="选择日期">
              </el-date-picker>
            </el-descriptions-item>
          </el-descriptions>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="body">
      <div class="table-wrap">
        <el-table
          v-loading="loading"
          v-if="pageData" :data="pageData.list"
          @selection-change="handleSelectionChange"
          border
          style="width: 100%">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            prop="house_name"
            label="房产" width="320">
            <template slot-scope="scope">
              <el-link type="primary" @click="setComponents('CustomerRentEditor',scope.row.id)">{{scope.row.house_name}}</el-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="intention_date"
            label="放租日期"
            width="100">
          </el-table-column>
          <el-table-column
            prop="is_ceased"
            label="状态"
            width="100">
            <template slot-scope="scope">
              出租中
            </template>
          </el-table-column>
          <el-table-column
            prop="contract_id"
            label="合同编号"
            width="100">
          </el-table-column>
          <el-table-column
            prop="phone"
            label="联系方式"
            width="100">
          </el-table-column>
          <el-table-column
            prop="extent"
            label="面积"
            width="100">
          </el-table-column>
          <el-table-column
            prop="furniture"
            label="家私配备"
            width="100">
          </el-table-column>
          <el-table-column
            prop="rent"
            label="意向租金"
            width="100">
          </el-table-column>
          <el-table-column
            prop="deposit"
            label="押金"
            width="100">
          </el-table-column>
          <el-table-column
            prop="management_expense"
            label="管理费"
            width="100">
          </el-table-column>
          <el-table-column
            prop="water_electricity"
            label="水电费"
            width="100">
          </el-table-column>
          <el-table-column
            prop="orther"
            label="其他要求"
            width="100">
          </el-table-column>
          <el-table-column
            prop="op_user_name"
            label="操作人"
            width="100">
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                       :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                       @current-change="pageChange"></el-pagination>
      </div>
    </div>

    <editor v-model="editor.visable" :classValue="editor.classValue" :id="editor.id" :is_edit="false" @callback="editorCallback" />
  </div>
</template>

<script>
import Editor from "../../../../Customer/editor";

export default {
  name: "CustomerRentMain",
  components:{Editor},
  inject:["mainObj","setComponentsId"],
  data(){
    return{
      where:{
        house_id:"",
        house_name:"",
        txtOwnerName:"",
        dateArr: [],
      },
      loading:false,
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
      },
      editor:{
        classValue:1,
        id:0,
        visable:false
      },
      ids: [],
    }
  },
  mounted(){
    this.where.dateArr = this.getNowTime();
  },
  activated() {
    this.where.house_id=this.house_id;
    this.where.house_name=this.house_name;
    this.getList()
  },
  watch: {
    house_id(n,o){
      this.where.house_id=n;
    },
    house_name(n,o){
      this.where.house_name=n;
      this.pageChange(1)
    }
  },
  computed:{
    house_id(){
      return (this.mainObj||{}).house_id||''
    },
    house_name(){
      return (this.mainObj||{}).house_name||''
    },
  },
  methods:{
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    getList() {
      const that=this;
      let where={
        ...that.where,
        pageSize:that.pageData.pageSize,
        page:that.pageData.page,
      }
      ERP.postRequest({url:"admin/HouseRentIntention/getList",data:where},ret=>{
        if(ret.code){
          that.pageData=ret.data;
        }else{
          this.$msgbox.alert(ret.msg||"查询失败")
        }
      })
    },
    showEditor(customer_id) {
      const that=this;
      that.getCustomerBase(customer_id,data=>{
        that.editor.classValue = data.class
        that.editor.id = customer_id
        that.editor.visable = true
      })
    },
    getCustomerBase(customer_id,callback){
      ERP.getRequest({
        url: "admin/Customer/getCustomerBase",
        data: {
          id: customer_id,
        }
      }, res => {
        if (res.code) {
          typeof callback ==="function"&&callback(res.data);
        }
      })
    },
    editorCallback(arg) {
      // this.getList()
      if(arg && arg[0]) this.editor.id = arg[0]
    },
    setComponents(componentsId,id=""){
      this.mainObj.rent_id=id;
      this.setComponentsId(componentsId)
    },
    goExcel(is_ceased=0){
      this.mainObj.excel_type=is_ceased;
      this.setComponentsId("CustomerRentBatch")
    },
    getNowTime() {
      // let start = new Date(new Date().getTime() - 3600 * 1000 * 24 * 30)
      //     .toISOString()
      //     .replace('T', ' ')
      //     .split('.')[0] //默认开始时间7天前

      let year = new Date().getFullYear();
      let month = new Date().getMonth();
      month = month + 1;
      if (month < 10 ) {
        month = '0' + month;
      }
      let start = year + '-' + month + '-01';

      let end = new Date(new Date().getTime())
        .toISOString()
        .replace('T', ' ')
        .split('.')[0]//默认结束时间

      // start = start.substring(0,10)
      end = end.substring(0,10)
      return [start, end]
    },
    handleSelectionChange(data) {
      let ids = data.map((item) => {
        return item.id;
      });
      this.ids = ids;
    },
    deleteSms(id) {
      let ids = [];
      if (id !== undefined) {
        ids = [id];
      } else {
        ids = this.ids;
      }
      console.log(ids)
      if (ids.length == 0) {
        this.$message.error("请选择要删除的数据");
        return;
      }

      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {

                ERP.postRequest({url:"admin/HouseRentIntention/deleteRent",data:ids},ret=>{
                  if(ret.code==1){
                    this.getList()
                    this.$message({
                      type: 'success',
                      message: '删除成功!'
                    });
                  }else{
                    this.$msgbox.alert(ret.msg||"查询失败")
                  }
                })

              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消删除'
                });
              });
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/components/rentIntention/CustomerRentMain.vue